<ng-container *ngFor="let item of media">
  <sn-incident-media-list-item
    [item]="item"
    (fileDeleted)="emitItem($event)"
  ></sn-incident-media-list-item>
</ng-container>
